module.exports = __webpack_public_path__ + "assets/img/FinancialTextReview-banner.034a0528.png";